<div class="sh-page-template__main__content sh-report-detail">
    <sh-page-header
        [title]="reportTitle$ | async"
        [contextItems]="reportDescription$ | async"
        [primaryNavigationItems]="navigationItems"
        [fullWithContext]="true"
    ></sh-page-header>

    @if (reportEmbedUrl$ | async; as url) {
        <div class="sh-panel sh-report-detail__panel">
            <iframe title="report" class="sh-report__panel__frame" [src]="url.toString() | safeResourceUrl"></iframe>
        </div>
    }

    @if (error$ | async) {
        <sh-notification [message]="'reports.detail.messages.failed-to-fetch' | translate" [type]="notificationType.Error" [icon]="'delete'"></sh-notification>
    }
    @if (loading$ | async) {
        <sh-notification [message]="'ui.loading' | translate"></sh-notification>
    }
</div>
